module.exports = __webpack_public_path__ + "img/ja.af3cdd0b.svg";